import InspectionStepLocalDB from "../../../models/indexedDB/inspection-step-local-db.entity";
import http from "../../../services/http.service";
import { rejectApiError } from "../../../services/api-error.service";

class InspectionService {
  private dataURLtoFile(dataurl: string, filename: string) {
 
    const arr = dataurl.split(',');
    // @ts-ignore
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
        
    while(n--){
      u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }

  createdFormDataToInspectEvent = (step: InspectionStepLocalDB): FormData => {
    const file: File = this.dataURLtoFile(step.photo.data, 'file.jpg');

    const bodyFormData = new FormData();
    bodyFormData.append('latitude', step.latitude
      ? `${step.latitude}`
      : '0');
    bodyFormData.append('longitude', step.longitude
      ? `${step.longitude}`
      : '0');
    bodyFormData.append('client_ip', '228.190.56.206');
    bodyFormData.append('accuracy', step.accuracy ? `${step.accuracy}` : '0');
    bodyFormData.append('file', file);
    bodyFormData.append('is_gps_browser', `1`);
    bodyFormData.append('applet_subgroup_id', step.appletSubgroupId);

    if (step.vehicleData) {
      bodyFormData.append('chassis', step.plate);
      bodyFormData.append('inspection_type', 'AGRICULTURAL_MACHINERY');
      bodyFormData.append('vehicle_data[brand]', step.vehicleData.brand);
      bodyFormData.append('vehicle_data[model]', step.vehicleData.model);
      bodyFormData.append('vehicle_data[version]', step.vehicleData.version);
      bodyFormData.append('vehicle_data[vehicle_type]', step.vehicleData.vehicleType);
      bodyFormData.append('vehicle_data[year_manufacture]', step.vehicleData.yearManufacture);
    } else {
      bodyFormData.append('plate', step.plate);
    }

    bodyFormData.append('offline_reference', step.uniqueIdentifier);
    bodyFormData.append('applet_profile_id', step.appletProfileId);

    return bodyFormData;
  };

  close = async (inspectionId: string) => http
    .post('/inspection-event-fleet-confirm', { inspection_id: inspectionId })
    .catch(rejectApiError);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new InspectionService();
